import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import EventScope from 'owa-service/lib/contract/EventScope';
import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import { ClientItemId } from 'owa-client-ids';
import { getCalendarEventService } from './getCalendarEventService';
import { getBirthdayEventService } from './getBirthdayEventService';
import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';
import { getCalendarEntryByFolderId } from 'owa-calendar-cache';
import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import {
    INLINEIMAGE_CUSTOM_DATA_TEMPLATE,
    INLINEIMAGE_URL_TEMPLATE,
} from 'owa-inline-image-consts';
import ItemId from 'owa-service/lib/contract/ItemId';

/**
 * Loads the calendar event from the server based on item id
 * @param id id of the event that we want to load
 * @param getSeriesMaster flag which says whether we want series master or series instance
 */
export function loadCalendarEvent(
    id: ClientItemId,
    parentFolderId: string,
    eventScope: EventScope = EventScope.Default,
    seriesMasterId: ItemId = undefined
): Promise<CalendarEvent> {
    const calendarEntry: CalendarEntry = getCalendarEntryByFolderId(parentFolderId);
    if (
        calendarEntry &&
        calendarEntry.CalendarFolderType == CalendarFolderTypeEnum.BirthdayCalendar
    ) {
        // invoke the getirthdayEvent operation to get calendar event for birthday
        return getBirthdayEventService(id, parentFolderId);
    }
    let shape: ItemResponseShape = {
        BaseShape: 'IdOnly',
        MaximumBodySize: 0, // No body truncation
        BodyType: 'HTML',
        InlineImageCustomDataTemplate: INLINEIMAGE_CUSTOM_DATA_TEMPLATE,
        InlineImageUrlTemplate: INLINEIMAGE_URL_TEMPLATE,
        AddBlankTargetToLinks: true,
    };

    // Invoke the service to get the data
    return getCalendarEventService(id, shape, eventScope, seriesMasterId);
}
